import {createAction} from '@reduxjs/toolkit';
import {Session} from '../../graph/auth';

export const updateUserDarkMode = createAction<{userDarkMode: boolean}>('user/updateUserDarkMode');
export const updateMarchesDarkMode = createAction<{matchesDarkMode: boolean}>('user/updateMarchesDarkMode');
export const updateUserSession = createAction<{session: Session | null}>('user/updateUserSession');
